import apiMiddleware from "../../../api/apiMiddleware";

// list destinations with pagination and search
const list = async ({ page = 1, search = "" }) => {
  const response = await apiMiddleware.get(
    `destination?page=${page}${search ? `&search=${search}` : ""}`
  );
  return response.data;
};

// create destination
const create = async (formData) => {
  const response = await apiMiddleware.post("destination", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// get destination by id
const getById = async (id) => {
  const response = await apiMiddleware.get(`destination/${id}`);
  return response.data;
};

// update destination
const update = async ({ id, formData }) => {
  const response = await apiMiddleware.post(
    `destination/${id}?_method=put`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return response.data;
};

// delete destination
const deleteDestination = async (id) => {
  const response = await apiMiddleware.delete(`destination/${id}`);
  return response.data;
};

// get state options
const getStateOptions = async () => {
  const response = await apiMiddleware.get("state-options");
  return response.data;
};

export { list, create, getById, update, deleteDestination, getStateOptions };
